import { useState } from "react";
import ActionOptions from "../Molecules/ActionOptions";
import DropdownMenu from "../Molecules/DropdownMenu";
import UserInfo from "../Molecules/UserInfo";
import styles from "../../Styles/OptionBar.module.css";
import SearchInput from "../Molecules/SearchInput";
import Button from "../Atoms/Button";
import { useDispatch } from "react-redux";
import { noteActions } from "../../../Store/note-slice";
const OPTIONS = ["Filter by Title", "Filter by Text"];

const OptionBar = ({
  params,
  logOut,
  toggleDropdown,
  showItems,
}) => {
  const [optionFilter, setOptionFilter] = useState("Title");
  const dispatch = useDispatch();

  const logOutHandler = () => {
    logOut();
  };

  const optionHandler = (option) => {
    let selection = option !== OPTIONS[1] ? "Title" : "Text";
    setOptionFilter(selection);
  };

  const inputHandler = (values) => {
    dispatch(noteActions.setFilterType({ filterType: values.type }));
    dispatch(noteActions.inputFilterSetter({ filterInput: values.input }));
  };

  return (
    <div className={styles.option}>
      <div className={styles.option_up}>
        <div className={styles.option_left}>
          <ActionOptions params={params} />
        </div>
        <div className={styles.option_right}>
          <Button clicked={logOutHandler}>Log Out</Button>
          <UserInfo userName={params} />
        </div>
      </div>
      <div className={styles.option_down}>
        <div className={styles.option_left}>
          <DropdownMenu
            option={optionHandler}
            toggle={toggleDropdown}
            show={showItems}
            OPTIONS={OPTIONS}
          />
        </div>
        <div className={styles.option_right}>
          <SearchInput inputHandler={inputHandler} selection={optionFilter} />
        </div>
      </div>
    </div>
  );
};

export default OptionBar;
